import { Playground } from '@playground';
import { BetaHeader } from "../../../../../packages/layout/src/components/beta/beta";
import * as React from 'react';
export default {
  Playground,
  BetaHeader,
  React
};